import { documentClient } from 'shared/domain/document/documentClient';
import type { DocumentUrlsResult } from 'shared/domain/document/documentUrlsModel';
import { isChannelRequestTimeout } from 'shared/channels/errors';

const DEFAULT_RETRY_DELAYS_MS = [300, 800, 1600] as const;

export class DocumentService {
  async resolveDocumentUrlsWithRetry(
    localId: number,
    retryDelaysMs: readonly number[] = DEFAULT_RETRY_DELAYS_MS,
    retryIndex = 0,
    forceRefresh = false
  ): Promise<DocumentUrlsResult> {
    try {
      return await documentClient.getUrls({ localId, forceRefresh });
    } catch (error) {
      // A timeout already waited for the worker (and retried once); retry only its answers.
      if (retryIndex >= retryDelaysMs.length || isChannelRequestTimeout(error)) {
        throw error;
      }

      await new Promise((resolve) => {
        setTimeout(resolve, retryDelaysMs[retryIndex]);
      });

      return this.resolveDocumentUrlsWithRetry(
        localId,
        retryDelaysMs,
        retryIndex + 1,
        forceRefresh
      );
    }
  }
}

export const documentService = new DocumentService();
